import styled from "styled-components";

export const LoginTemplate = styled.div`
  display: grid;
  grid-template-columns: 1fr minmax(min-content, 53.5rem) 1fr;
  grid-template-rows: 33vh 1fr;
  min-height: 100vh;
  justify-items: center;

  .custom-form-label {
    .ant-form-item-label {
      margin-left: 12.5%;

      label {
        color: ${({ theme }) => theme.colors.blueDianne};
        font-size: ${({ theme }) => theme.fontSize.l};
        font-weight: 600;
        letter-spacing: 0.09em;

        &.ant-form-item-required {
          &::before {
            content: "";
          }
        }
      }
    }
  }
`;

export const LoginWrapper = styled.div`
  width: 100%;
  grid-column: 2;
`;

export const Center = styled.div`
  align-self: center;
  grid-column: 2;
`;
